import React, { useState, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import "date-fns";
import { createTheme } from "@material-ui/core/styles";
import axios from "axios";
import Button from "@material-ui/core/Button";
import { HOST_URL } from "../../../Config";
import { StoreContext } from "../../../Store/Provider";
import { NotificationManager } from "react-notifications";
import { TextField, Autocomplete } from "@mui/material";
import CargoAdd1 from "./cargoAdd/CargoAdd1";
import CargoAdd2 from "./cargoAdd/CargoAdd2";
import useForm from "../../Common/hooks/useForm";
import { getUserData, localStoragekey } from "../../Common/Utility/Utils";
import TransportMode from "./TranportModeJSON";
import NewExcelJSON from "./NewExcelJson";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import InquirySuccessModal from "./ScheduleSearchResult/InquirySuccessModal";

const materialTheme = createTheme({
  palette: {
    primary: {
      main: "rgba(0, 185, 181)",
    },
  },
});

const useStyles = makeStyles({
  paper: {
    fontSize: "0.9rem",
  },
});
function InquiryForm() {
  const classes = useStyles();
  const context = useContext(StoreContext);
  const compName = useForm();
  const contactPerson = useForm();
  const contact = useForm();
  const email = useForm();
  const cargoType = useForm();
  const cargoTypeDesc = useForm();
  const incTerm = useForm();
  const companyType = useForm();
  const modeTrans = useForm();
  const movType = useForm();
  const remarks = useForm();
  const orgCountry = useForm({ name: "" });
  const orgCity = useForm({ name: "" });
  const destCountry = useForm({ name: "" });
  const destCity = useForm({ name: "" });
  const destCityPinCode = useForm();
  const orgCityPinCode = useForm();
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [arrayIndex, setArrayIndex] = useState(null);
  const [countryObjectOption, setCountryObjectOption] = useState([]);
  const [originportObjectOption, setOriginportObjectOption] = useState([]);
  const [destinationportObjectOption, setDestinationportObjectOption] =
    useState([]);
  const [incoterm, setIncoterm] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);
  const [apiLoading, setApiLoading] = useState({
    country: false,
    orgPort: false,
    destPort: false,
    currency: false,
    dubaiPort: false,
    dubaiCity: false,
    gccCountry: false,
  });
  const [cargoAddArray, setCargoAddArray] = useState([]);
  const cargoAddObj = {
    pkgType: "",
    quantity: 0,
    length: 0,
    width: 0,
    height: 0,
    dimensionUnit: "",
    weight: 0,
    weightUnit: "",
    stackable: "No",
    containerType: "",
  };
  useEffect(() => {
    getCountry();
    getIncoTerm();
  }, []);
  const getCountry = () => {
    setApiLoading({ ...apiLoading, country: true });
    const URL = `${HOST_URL}api/GetAllCountries`;
    axios
      .get(URL)
      .then((res) => {
        let arr = [];
        res.data.countries.forEach((countrylist) => {
          arr.push({
            name: `${countrylist.name} (${countrylist.key})`,
            key: countrylist.key,
          });
        });
        setCountryObjectOption([...arr]);
        setApiLoading({ ...apiLoading, country: false });
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error("Something went wrong!", "", 3000);
        setApiLoading({ ...apiLoading, country: false });
      });
  };
  const getPort = (type, key) => {
    if (type === "org") {
      setApiLoading({ ...apiLoading, orgPort: true });
    } else if (type === "dest") {
      setApiLoading({ ...apiLoading, destPort: true });
    }
    const URL = `${HOST_URL}api/GetPorts?country_code=${key}`;
    axios
      .get(URL)
      .then((res) => {
        let arr = [];
        res.data.ports.forEach((portslist) => {
          arr.push({
            name: `${portslist.name} (${portslist.key})`,
            key: portslist.key,
          });
        });
        if (type === "org") {
          setOriginportObjectOption([...arr]);
          setApiLoading({ ...apiLoading, orgPort: false });
        } else if (type === "dest") {
          setDestinationportObjectOption([...arr]);
          setApiLoading({ ...apiLoading, destPort: false });
        }
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error("Something went wrong!", "", 3000);
        if (type === "org") {
          setApiLoading({ ...apiLoading, orgPort: false });
        } else if (type === "dest") {
          setApiLoading({ ...apiLoading, destPort: false });
        }
      });
  };

  const getIncoTerm = () => {
    const URL = `${HOST_URL}api/v1/Shipment/IncoTerm`;
    axios
      .post(URL)
      .then((res) => {
        let arr = [];
        res?.data?.Value.forEach((inco) => {
          arr.push(inco.Name);
        });
        setIncoterm(arr);
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error("Something went wrong!", "", 3000);
      });
  };

  const changeMode = async (event, newValue) => {
    orgCityPinCode.setValue("");
    destCityPinCode.setValue("");
    setCargoAddArray([]);
    await resetSchedule(false);
    modeTrans.setValue(newValue?.value ?? "");
    if (newValue) {
      setArrayIndex(newValue.type);
      let arr = [];
      arr.push(cargoAddObj);
      setCargoAddArray([...arr]);
    } else {
      setArrayIndex(null);
      setCargoAddArray([]);
    }
  };
  const onCargoTypeChange = (index, key, value) => {
    let arr = [...cargoAddArray];
    if (
      key === "quantity" ||
      key === "length" ||
      key === "width" ||
      key === "height" ||
      key === "weight"
    ) {
      arr[index][key] = parseInt(value);
    } else {
      arr[index][key] = value;
    }
    setCargoAddArray([...arr]);
  };
  const onCargoAdd = () => {
    let arr = [...cargoAddArray];
    arr.push(cargoAddObj);
    setCargoAddArray(arr);
  };
  const onCargoRemove = (index) => {
    const arr = [...cargoAddArray];
    arr.splice(index, 1);
    setCargoAddArray([...arr]);
  };
  const resetSchedule = (transportModeClear = true) => {
    if (transportModeClear) {
      compName.setValue("");
      contactPerson.setValue("");
      contact.setValue("");
      email.setValue("");
      companyType.setValue("");
      modeTrans.setValue("");
      orgCityPinCode.setValue("");
      destCityPinCode.setValue("");
      remarks.setValue("");
    }
    remarks.setValue("");
    incTerm.setValue("");
    orgCountry.setValue({ name: "" });
    orgCity.setValue({ name: "" });
    destCountry.setValue({ name: "" });
    destCity.setValue({ name: "" });
    movType.setValue("");
    cargoType.setValue("");
    cargoTypeDesc.setValue("");
    setArrayIndex(0);
    setOriginportObjectOption([]);
    setDestinationportObjectOption([]);
    setCargoAddArray([]);
  };
  const inquirySend = async () => {
    setLoading(true);
    let userData = {};
    await getUserData(localStoragekey)
      .then((res) => {
        userData = res;
      })
      .catch((err) => {
        userData = {};
      });
    const header = {
      Authorization: `Bearer ${userData?.access_token}`,
      username: `${userData?.userName}`,
      grant_type: "password",
      password: `${userData?.userSecret}`,
    };
    const params = {
      Inquiry_Organization: context.isUserLogin
        ? JSON.parse(localStorage.getItem(localStoragekey))?.orgs
        : compName.value,
      Inquiry_ContactName: context.isUserLogin
        ? JSON.parse(localStorage.getItem(localStoragekey))?.userFullName
        : contactPerson.value,
      Inquiry_Phone: context.isUserLogin
        ? JSON.parse(localStorage.getItem(localStoragekey))?.Phone
        : contact.value,
      Inquiry_EMail: context.isUserLogin
        ? JSON.parse(localStorage.getItem(localStoragekey))?.EMail
        : email.value,
      Inquiry_CompanyType: companyType.value,
      Inquiry_TransportMode: modeTrans.value,
      Inquiry_MovementType: movType.value,
      Inquiry_IncoTerm: incTerm.value,
      Inquiry_OriginCountry: orgCountry.value?.name ?? "",
      Inquiry_OriginPort: orgCity.value?.name ?? "",
      Inquiry_OriginPinCode: orgCityPinCode.value ?? "",
      Inquiry_DestinationCountry: destCountry.value?.name ?? "",
      Inquiry_DestinationPort: destCity.value?.name ?? "",
      Inquiry_DestinationPinCode: destCityPinCode?.value ?? "",
      Inquiry_CargoType: cargoType.value,
      Inquiry_CargoTypeDescription: cargoTypeDesc.value,
      Inquiry_CargoDetails: cargoAddArray,
      Inquiry_Remarks: remarks.value,
    };
    const end_point = `${HOST_URL}api/v1/Shipment/INQUIRY`;
    axios
      .post(end_point, params, {
        headers: context.isUserLogin ? header : null,
      })
      .then((res) => {
        if (res.data.Success) {
          // NotificationManager.success(res.data.ResultMessage, "", 3000);
          setOpen(true);
          resetSchedule();
        } else {
          NotificationManager.error(res.data.ResultMessage, "", 3000);
        }
      })
      .catch((err) => {
        NotificationManager.error("Something went wrong", "", 3000);
      });
    setLoading(false);
  };
  const onMovementTypeChangeOrig = (e) => {
    orgCityPinCode.setValue(e.target.value);
  };

  const onMovementTypeChangeDest = (e) => {
    destCityPinCode.setValue(e.target.value);
  };

  const onPostComment = (e) => {
    setComment(e.target.value);
  };
  console.log(arrayIndex);
  return (
    <>
      <div className="row my-3 scheduleCompSelectInner inquiryFormComp">
        <InquirySuccessModal open={open} handleClose={handleClose} />
        {context.isUserLogin ? null : (
          <>
            <div className="col-lg-4 col-md-6 col-12">
              <TextField
                variant="standard"
                label={<div className="inquiryLabel">Company Name*</div>}
                size="small"
                value={compName.value}
                onChange={compName.onChange}
                error={compName.error}
                helperText={compName.errorMsg}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <TextField
                variant="standard"
                label={<div className="inquiryLabel">Contact Person*</div>}
                size="small"
                value={contactPerson.value}
                onChange={contactPerson.onChange}
                error={contactPerson.error}
                helperText={contactPerson.errorMsg}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <TextField
                variant="standard"
                label={<div className="inquiryLabel">Contact Number*</div>}
                size="small"
                value={contact.value}
                onChange={contact.onChange}
                error={contact.error}
                helperText={contact.errorMsg}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <TextField
                variant="standard"
                label={<div className="inquiryLabel">E-mail</div>}
                size="small"
                value={email.value}
                onChange={email.onChange}
                error={email.error}
                helperText={email.errorMsg}
              />
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <Autocomplete
                disablePortal
                size="small"
                value={companyType.value}
                onChange={(event, newValue) => companyType.setValue(newValue)}
                options={["Individual", "SME", "Corporate"]}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField
                    variant="standard"
                    {...params}
                    label="Company Type"
                    error={companyType.error}
                    helperText={companyType.errorMsg}
                  />
                )}
              />
            </div>
            <div className="clearfix"></div>
          </>
        )}
        <div className="col-lg-4 col-md-6 col-12">
          <Autocomplete
            disablePortal
            size="small"
            value={modeTrans.value}
            onChange={(event, newValue) => changeMode(event, newValue)}
            options={TransportMode ?? []}
            // getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField
                variant="standard"
                {...params}
                label="Transport Mode*"
                error={modeTrans.error}
                helperText={modeTrans.errorMsg}
              />
            )}
          />
        </div>
        <div className="clearfix"></div>
        {modeTrans.value ? (
          <>
            {NewExcelJSON[arrayIndex].MovementType === "Y" ? (
              <div className="col-lg-4 col-md-6 col-12">
                <Autocomplete
                  disablePortal
                  size="small"
                  value={movType.value}
                  onChange={(event, newValue) => {
                    orgCityPinCode.setValue("");
                    destCityPinCode.setValue("");
                    movType.setValue(newValue);
                  }}
                  options={[
                    "Door to Door",
                    "Door to Port",
                    "Port to Door",
                    "Port to Port",
                  ]}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      variant="standard"
                      {...params}
                      label="Movement Type"
                      error={movType.error}
                      helperText={movType.errorMsg}
                    />
                  )}
                />
              </div>
            ) : null}
            {NewExcelJSON[arrayIndex].OriginCountry === "Y" ? (
              <div className="col-lg-4 col-md-6 col-12">
                <Autocomplete
                  disablePortal
                  size="small"
                  value={orgCountry.value}
                  onChange={(event, newValue) => {
                    orgCountry.setValue(newValue);
                    getPort("org", newValue?.key);
                  }}
                  options={
                    // NewExcelJSON[arrayIndex]["GCC"]
                    //   ? countryGCCObjectOption
                    //   : NewExcelJSON[arrayIndex]["GCC"] === "N"
                    // ?
                    countryObjectOption ?? []
                  }
                  getOptionLabel={(option) => option.name}
                  classes={{ listbox: classes.paper }}
                  renderInput={(params) => (
                    <TextField
                      variant="standard"
                      {...params}
                      label="Origin Country"
                      error={orgCountry.error}
                      helperText={orgCountry.errorMsg}
                    />
                  )}
                />
              </div>
            ) : null}
            {NewExcelJSON[arrayIndex].OriginCity === "Y" ? (
              <div className="col-lg-4 col-md-6 col-12">
                <Autocomplete
                  disablePortal
                  size="small"
                  value={orgCity.value}
                  onChange={(event, newValue) => orgCity.setValue(newValue)}
                  classes={{ listbox: classes.paper }}
                  options={originportObjectOption ?? []}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      variant="standard"
                      {...params}
                      label="Origin Port"
                      error={orgCity.error}
                      helperText={orgCity.errorMsg}
                    />
                  )}
                />
              </div>
            ) : null}
            {NewExcelJSON[arrayIndex].OriginCityPinCode === "Y" &&
            (movType.value === "Door to Door" ||
              movType.value === "Door to Port") ? (
              <div className="col-lg-4 col-md-6 col-12">
                <TextField
                  variant="standard"
                  label={
                    <div className="inquiryLabel">Origin City Pincode</div>
                  }
                  size="small"
                  value={orgCityPinCode.value}
                  onChange={onMovementTypeChangeOrig}
                  error={orgCityPinCode.error}
                  helperText={orgCityPinCode.errorMsg}
                />
              </div>
            ) : null}
            {NewExcelJSON[arrayIndex].DestinationCountry === "Y" ? (
              <div className="col-lg-4 col-md-6 col-12">
                <Autocomplete
                  disablePortal
                  size="small"
                  value={destCountry.value}
                  onChange={(event, newValue) => {
                    destCountry.setValue(newValue);
                    getPort("dest", newValue?.key);
                  }}
                  options={
                    // NewExcelJSON[arrayIndex]["GCC"]
                    //   ? countryGCCObjectOption
                    //   : NewExcelJSON[arrayIndex]["GCC"] === "N"
                    //   ?
                    countryObjectOption ?? []
                    // : []
                  }
                  classes={{ listbox: classes.paper }}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => (
                    <TextField
                      variant="standard"
                      {...params}
                      label="Destination Country"
                      error={destCountry.error}
                      helperText={destCountry.errorMsg}
                    />
                  )}
                />
              </div>
            ) : null}
            {NewExcelJSON[arrayIndex].DestinationCity === "Y" ? (
              <div className="col-lg-4 col-md-6 col-12">
                <Autocomplete
                  disablePortal
                  loading={apiLoading.destPort}
                  size="small"
                  value={destCity.value}
                  onChange={(event, newValue) => destCity.setValue(newValue)}
                  options={destinationportObjectOption ?? []}
                  getOptionLabel={(option) => option.name}
                  classes={{ listbox: classes.paper }}
                  renderInput={(params) => (
                    <TextField
                      variant="standard"
                      {...params}
                      label="Destination Port"
                      error={destCity.error}
                      helperText={destCity.errorMsg}
                    />
                  )}
                />
              </div>
            ) : null}
            {NewExcelJSON[arrayIndex].DestinationCityPinCode === "Y" &&
            (movType.value === "Port to Door" ||
              movType.value === "Door to Door") ? (
              <div className="col-lg-4 col-md-6 col-12">
                <TextField
                  variant="standard"
                  label={
                    <div className="inquiryLabel">Destination City Pincode</div>
                  }
                  size="small"
                  value={destCityPinCode.value}
                  onChange={onMovementTypeChangeDest}
                  error={destCityPinCode.error}
                  helperText={destCityPinCode.errorMsg}
                />
              </div>
            ) : null}
            {NewExcelJSON[arrayIndex].IncoTerm === "Y" ? (
              <div className="col-lg-4 col-md-6 col-12">
                <Autocomplete
                  disablePortal
                  size="small"
                  value={incTerm.value}
                  onChange={(event, newValue) => incTerm.setValue(newValue)}
                  options={incoterm ?? []}
                  getOptionLabel={(option) => option}
                  renderInput={(params) => (
                    <TextField
                      variant="standard"
                      {...params}
                      label="Inco Term"
                      error={incTerm.error}
                      helperText={incTerm.errorMsg}
                    />
                  )}
                />
              </div>
            ) : null}

            {NewExcelJSON[arrayIndex].Cargotype === "Y" ? (
              <>
                <div className="col-lg-4 col-md-6 col-12">
                  <Autocomplete
                    disablePortal
                    size="small"
                    value={cargoType.value}
                    onChange={(event, newValue) => cargoType.setValue(newValue)}
                    options={[
                      "General Cargo",
                      "Refer or Temp. controlled goods",
                      "Hazardous",
                      "Personal",
                      "Event cargo",
                      "Live Animals",
                      "Used Items",
                      "Others",
                    ]}
                    classes={{ listbox: classes.paper }}
                    getOptionLabel={(option) => option}
                    renderInput={(params) => (
                      <TextField
                        variant="standard"
                        {...params}
                        label="Cargo Type"
                        error={cargoType.error}
                        helperText={cargoType.errorMsg}
                      />
                    )}
                  />
                </div>
                {cargoType.value === "Others" ? (
                  <div className="col-lg-4 col-md-6 col-12">
                    <TextField
                      variant="standard"
                      label={
                        <div className="inquiryLabel">
                          Cargo Type Description
                        </div>
                      }
                      size="small"
                      value={cargoTypeDesc.value}
                      onChange={cargoTypeDesc.onChange}
                      error={cargoTypeDesc.error}
                      helperText={cargoTypeDesc.errorMsg}
                    />
                  </div>
                ) : null}
              </>
            ) : null}
            <div className="col-lg-4 col-md-6 col-12">
              <textarea
                rows={1}
                placeholder="Remarks"
                className="form-control textareaRemarks"
                value={remarks.value}
                onChange={(event) => remarks.setValue(event.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    onPostComment();
                  }
                }}
              />
            </div>
            <div className="col-12 cargoAddHead">
              <h4>Cargo Details</h4>
              <div>
                <Button onClick={onCargoAdd}>Add</Button>
              </div>
            </div>
            <div className="cargoAddParent col-12">
              {NewExcelJSON[arrayIndex].CargoAdd === "1" ? (
                <Table>
                  <TableHead>
                    <TableRow className="cargoAddTableHead">
                      <TableCell>Package Type</TableCell>
                      <TableCell>Quantity</TableCell>
                      <TableCell>Dimensional Unit</TableCell>
                      <TableCell>Length</TableCell>
                      <TableCell>Width</TableCell>
                      <TableCell>Height</TableCell>
                      <TableCell>Weight Unit</TableCell>
                      <TableCell>Weight Per Piece</TableCell>
                      <TableCell>Stackable</TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cargoAddArray?.map((ele, index) => (
                      <CargoAdd1
                        palletOrpiece={
                          NewExcelJSON[arrayIndex]["value"] === "WAREHOUSE"
                            ? "Pallet"
                            : "Piece"
                        }
                        cargoTypeAddOptions={[
                          "Pallets",
                          "Skids",
                          "Crates",
                          "Boxes",
                          "Cartons",
                          "Cases",
                          "Packages",
                          "Drums",
                          "Bags",
                          "Rolls",
                        ]}
                        weightUnitOptions={["kg", "Ton", "lb"]}
                        dimensionUnitOptions={["mm", "cm", "in", "m"]}
                        onCargoRemove={
                          cargoAddArray.length > 1 ? onCargoRemove : () => {}
                        }
                        length={cargoAddArray.length}
                        element={ele}
                        index={index}
                        onChange={onCargoTypeChange}
                      />
                    ))}
                  </TableBody>
                </Table>
              ) : NewExcelJSON[arrayIndex].CargoAdd === "2" ? (
                <Table>
                  <TableHead>
                    <TableRow className="cargoAddTableHead">
                      <TableCell>Quantity</TableCell>
                      <TableCell>Container Type</TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {cargoAddArray?.map((ele, index) => (
                      <CargoAdd2
                        cargoContainerTypeOptions={[
                          "20ft",
                          "40ft",
                          "40HC",
                          "20OT",
                          "40OT",
                          "20FR",
                          "40FR",
                          "20RE",
                          "40RE",
                        ]}
                        onCargoRemove={
                          cargoAddArray.length > 1 ? onCargoRemove : () => {}
                        }
                        length={cargoAddArray.length}
                        element={ele}
                        index={index}
                        onChange={onCargoTypeChange}
                      />
                    ))}
                  </TableBody>
                </Table>
              ) : null}
            </div>
          </>
        ) : null}
      </div>
      {modeTrans.value ? (
        <div className="shipmentheaderbuttongroups">
          <Button
            variant="contained"
            className="shipmentheaderbutton"
            onClick={resetSchedule}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            className="shipmentheaderbutton selected"
            onClick={inquirySend}
          >
            &nbsp;
            {loading ? (
              <CircularProgress size="1rem" color="inherit" />
            ) : (
              "Send"
            )}
            &nbsp;
          </Button>
        </div>
      ) : null}
    </>
  );
}

export default InquiryForm;
